import { api } from '@/api';
import type { ProjectUserRoles } from '@/features/projects/constants';
import { getLoggedUser } from '@/features/user/api';
import { queryOptions } from '@tanstack/react-query';

export const onboardingQuery = () =>
  queryOptions({
    queryKey: ['isUserOnBoard'],
    queryFn: async () => {
      const { data } = await getLoggedUser();
      const projectRoles = await api.get<{
        roles: { roleId: string; roleName: ProjectUserRoles }[];
      }>('v1/users/projectroles');

      const organizations = data.organizations.toSorted((a, b) => {
        if (a.isEnabled !== b.isEnabled) return a.isEnabled ? -1 : 1;
        return a.organizationName.localeCompare(b.organizationName);
      });

      const currentOrg = data.organizations.find(
        (org) => org.organizationId === data.organizationId,
      );
      const hasActiveOrganization = !!currentOrg?.isEnabled;
      const hasEnabledOrganization = data.organizations.some((org) => org.isEnabled);

      return {
        hasActiveOrganization,
        hasEnabledOrganization,
        userData: { ...data, organizations },
        projectRolesData: projectRoles.data,
      };
    },
  });
